import React from "react";
import Snowfall from "react-snowfall";
import Card from "src/components/Card";
import useAuth from "src/hooks/selectors/useAuth";

const ChristmasGiftCard = () => {
	const auth = useAuth();
	const count = auth?.company?.promotions?.christmas_donations || 0;
	return (
		<Card
			to="/tasks/create"
			className="bg-[#BB2528] relative overflow-hidden"
			contentClassName="text-white"
		>
			<div className="relative z-20">
				<h1>{`🎅 ${count}`}</h1>
				<strong>
					{count === 1 ? "Kerstgeschenk" : "Kerstgeschenken"}{" "}
					gedoneerd
				</strong>
			</div>
			<div className="absolute inset-0">
				<Snowfall snowflakeCount={20} changeFrequency={20} />
			</div>
			<div className="absolute right-4 -bottom-2">
				<p className="text-[80px]">🎄</p>
			</div>
		</Card>
	);
};

export default ChristmasGiftCard;
